"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "table-list-clients-component"
  }, [_vm.list && _vm.list.length > 0 ? _c("div", [_c("div", {
    staticClass: "list-itens-informations"
  }, [!_vm.isMobile ? _c("div", {
    staticClass: "header"
  }, [_c("div", {
    staticClass: "one"
  }), _vm._v(" "), _c("div", {
    staticClass: "one"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c("div", {
    staticClass: "two"
  }, [_vm._v("Nome")]), _vm._v(" "), _c("div", {
    staticClass: "three"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c("div", {
    staticClass: "four"
  }, [_vm._v("Setor")])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.list, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "body",
      on: {
        click: function click($event) {
          return _vm.actionItem(item);
        }
      }
    }, [_c("div", {
      staticClass: "one"
    }, [item.logo ? _c("img", {
      attrs: {
        src: item.logo
      }
    }) : _vm._e()]), _vm._v(" "), _c("div", {
      staticClass: "one"
    }, [_vm.isMobile ? _c("span", [_vm._v("CNPJ: ")]) : _vm._e(), _vm._v(_vm._s(_vm._f("maskCNPJ")(item.document)) + "\n        ")]), _vm._v(" "), _c("div", {
      staticClass: "two"
    }, [_vm.isMobile ? _c("span", [_vm._v("Nome: ")]) : _vm._e(), _vm._v(_vm._s(_vm._f("toUpperCase")(item.name)) + "\n        ")]), _vm._v(" "), _c("div", {
      staticClass: "three"
    }, [_vm.isMobile ? _c("span", [_vm._v("E-mail: ")]) : _vm._e(), _vm._v(_vm._s(item.email || "--") + "\n        ")]), _vm._v(" "), _c("div", {
      staticClass: "four"
    }, [_vm.isMobile ? _c("span", [_vm._v("Setor: ")]) : _vm._e(), _vm._v(_vm._s(_vm._f("toUpperCase")(item.setor)) + "\n        ")])]);
  })], 2)]) : _vm._e(), _vm._v(" "), !_vm.list || !_vm.list.length ? _c("div", [_c("h1", {
    staticClass: "empty-title"
  }, [_vm._v("\n      Sem dados no momento\n    ")])]) : _vm._e()]);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;